module.exports = __webpack_public_path__ + "media/vans/white-van-6b169709.svg";